<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.termsOfServices.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">{{ translations.forms.labels.title }}</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.title"
                        v-model="termsOfServices.title"
                      />
                      <form-error :model="$v.termsOfServices.title" :dirty="$v.$dirty" :label="translations.forms.labels.title"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.termsOfServices.content.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">{{ translations.forms.labels.content }}</label>
                    <div class="col-lg-7 col-xl-9">
                      <editor
                        name="html-editor"
                        :init="{
                          ...appSettings.tinyMceConfig
                        }"
                        v-model="termsOfServices.content"
                        id="content"
                      ></editor>

                      <form-error :model="$v.termsOfServices.content" :dirty="$v.$dirty" :label="translations.forms.labels.content"/>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link exact :to="{ name: 'Dashboard' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import editor from "@tinymce/tinymce-vue";

import { translations } from '@/mixins';
import validations from './validation-schema/terms';
import api from '@/services/api';
import config from '@/config';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  name: 'TermsOfServices',
  mixins: [translations],
  validations: {
    termsOfServices: validations,
  },
  components: { FormError, editor },
  data() {
    return {
      termsOfServices: {
        id: null,
        title: '',
        content: '',
      },
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
    storedTermsOfServices() {
      return this.$store.getters.getTermsOfServices;
    },
    appSettings() {
      return config.appSettings;
    },
  },
  watch: {
    storedTermsOfServices: {
      immediate: true,
      handler(terms) {
        this.termsOfServices = {
          id: terms?.id ?? null,
          title: terms?.title ?? '',
          content: terms?.content ?? '',
        };
      },
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      if (!this.termsOfServices.id) {
        this.$toast.error('Uslovi korištenja još nisu kreirani i ne mogu se ažurirati.');
        return;
      }

      api.updateTermsOfServices(this.termsOfServices)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
  mounted() {
    this.$store.dispatch('getTermsOfServices');
  },
};
</script>